module.exports = __webpack_public_path__ + "static/media/beep1.a7b4df69.mp3";